// Partnership IDs for different environments
export const NANIT_PARTNERSHIP_IDS = [
  'partnership_2umTzzEVS8C2mL7ebABpxNPOto5', // dev
  'partnership_2v5LawHohuOaNIJZfI0SjeoE55W', // sandbox
  'partnership_2urufRaibwceTpQIMfO8urhUTbT', // prod
] as const;

export const NANIT_COUPON_IDS = [
  'InZbqYwo', // dev
  'InZbqYwo', // sandbox
  'BJDysLAH', // prod
] as const;

export const NANIT_PROMO_CODES = ['NANIT83210', 'nanit83210'] as const;

export const isNanitPartnershipId = (partnershipId?: string): boolean =>
  NANIT_PARTNERSHIP_IDS.includes(
    partnershipId as (typeof NANIT_PARTNERSHIP_IDS)[number],
  );

export const isNanitPromoCode = (promoCode?: string): boolean =>
  NANIT_PROMO_CODES.includes(promoCode as (typeof NANIT_PROMO_CODES)[number]);

export const isNanitCouponId = (couponId?: string): boolean =>
  NANIT_COUPON_IDS.includes(couponId as (typeof NANIT_COUPON_IDS)[number]);
